module.exports = __webpack_public_path__ + "pc/img/10_SNS-Marketing.4df02fc2.png";